import { ErrorCodeType } from "application/models/IError";
import { getGlobalAddLog } from "Infrastructure/repositories/appInsights/AppInsights";
import { IUserRegisterService } from "modules/cpfRegister/service/UserRegisterService";
import { IDocumentOwner } from "modules/order/domain/models/IDocumentOwner";
import { GetError } from "utils/GetError";

const sanitizeDocument = (document: string) => document.replace(/\D/g, "");
const addLog = getGlobalAddLog();

export const GetDocumentOwnerUseCase = async (
  service: IUserRegisterService,
  document: string,
  localId: string
): Promise<IDocumentOwner | undefined> => {
  const cleanedDocument = sanitizeDocument(document);

  try {
    if (cleanedDocument.length === 14) {
      const response = await service.getCompanyData(localId, cleanedDocument);
      return {
        id: response.Id,
        document: response.CNPJ,
        name: response.Nome,
        type: "CNPJ",
      };
    }

    if (cleanedDocument.length === 11) {
      const response = await service.getUserData(localId, cleanedDocument);
      return {
        id: response.Id,
        document: response.CPF,
        name: response.Nome,
        type: "CPF",
      };
    }

    return undefined;
  } catch (error) {
    addLog && addLog("order", {
        message: "GetDocumentOwnerUseCase - erro ao consultar documento",
        document: cleanedDocument,
        localId,
        error,
      });
    GetError(
      error,
      "GetDocumentOwnerUseCase",
      "GetDocumentOwnerUseCase",
      "Falha ao consultar documento",
      ErrorCodeType.GENERAL
    );
  }
};
